import React from "react";
import {
  capitaliseWithHyphen,
  checkNumbervalue,
  checkSpecialCharacter,
  checkSpace,
} from "../../../utils";
import { Col, Form, DatePicker, Select, Input } from "antd";
import moment from "moment";
import CloneRateCardTemplate from "../../RateCardConfigMaster/CloneRateCardTemplate";
const QuotationForm = ({
  disable,
  hideCommitedBusiness,
  hideSelectTemplate,
  getTemplateDetails = () => {},
  colSpan = 4,
  showInvoiceType = true,
}) => {
  const dateFormat = "DD-MM-YYYY";
  const billingCycle = [
    { label: "Weekly", value: "WEEKLY" },
    { label: "Monthly", value: "MONTHLY" },
    { label: "Quaterly", value: "QUATERLY" },
  ];
  const invoiceList = [
    { label: capitaliseWithHyphen("REGULAR-PIECE"), value: "REGULAR-PIECE" },
    { label: capitaliseWithHyphen("REVERSE-PIECE"), value: "REVERSE-PIECE" },
    { label: capitaliseWithHyphen("REGULAR-SLAB"), value: "REGULAR-SLAB" },
    { label: capitaliseWithHyphen("REVERSE-SLAB"), value: "REVERSE-SLAB" },
  ];
  const disabledDate = (current) => {
    return current < moment().startOf("day");
  };
  const getFinancialEndDate = () => {
    const currentYear = moment().year();
    const financialEndYear =
      moment().month() >= 3 ? currentYear + 1 : currentYear; // Fiscal year ending March 31st
    return moment(`31-03-${financialEndYear}`, dateFormat);
  };

  return (
    <>
      {/* <Col span={2} /> */}
      <Col className="form-inputs" span={colSpan}>
        <Form.Item
          name="fromDate"
          label="Start Date"
          rules={[
            {
              required: true,
              message: "Please select start date",
            },
          ]}
        >
          <DatePicker
            style={{ width: "100%" }}
            disabledDate={disabledDate}
            format={dateFormat}
            disabled={disable}
          />
        </Form.Item>
      </Col>
      <Col className="form-inputs" span={colSpan}>
        <Form.Item
          name="toDate"
          label="End Date"
          initialValue={getFinancialEndDate()}
          rules={[
            {
              required: true,
              message: "Please select end date",
            },
          ]}
        >
          <DatePicker
            style={{ width: "100%" }}
            format={dateFormat}
            // disabledDate={(current) =>
            //   current && current > getFinancialEndDate()
            // }
            disabled={disable}
          />
        </Form.Item>
      </Col>
      {/* <Col span={2} />
      <Col span={2} /> */}

      <Col className="form-inputs" span={colSpan}>
        <Form.Item
          name="billingCycle"
          label="Billing Cycle"
          rules={[
            {
              required: true,
              message: "Please select billing cycle",
            },
          ]}
        >
          <Select
            placeholder="Select Billing Cycle"
            options={billingCycle}
            disabled={disable}
          />
        </Form.Item>
      </Col>
      {showInvoiceType && (
        <Col className="form-inputs" span={colSpan}>
          <Form.Item
            name="invoiceType"
            label="Invoice Type"
            rules={[
              {
                required: true,
                message: "Please select invoice type",
              },
            ]}
          >
            <Select
              placeholder="Select Invoice Type"
              options={invoiceList}
              disabled={disable}
            />
          </Form.Item>
        </Col>
      )}
      {/* <Col span={2} />
      <Col span={2} /> */}
      {!hideCommitedBusiness && (
        <Col className="form-inputs" span={colSpan}>
          <Form.Item
            name="commitedBusiness"
            label="Commited Business"
            rules={[
              {
                required: true,
                message: "Please enter commited business",
              },
            ]}
            onKeyPress={(event) => {
              if (
                checkNumbervalue(event) ||
                checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
          >
            <Input placeholder="Enter commited business" disabled={disable} />
          </Form.Item>
        </Col>
      )}
      {!hideSelectTemplate && (
        <Col className="form-inputs" span={colSpan}>
          <Form.Item name="templateId" label="Clone From Existing Template">
            <CloneRateCardTemplate
              getTemplateData={(data) => getTemplateDetails(data)}
            />
          </Form.Item>
        </Col>
      )}
    </>
  );
};

export default QuotationForm;
